import React from 'react';
import PropTypes from 'prop-types';
import useUserContext from 'Context/UserContext';
import { MemberMessageInput }
  from 'Components/ComponentLibrary/Components/Uncategorized/MessageInput/components/MemberMessageInput';
import { noop } from 'Helpers/PropTypes';
import fr from 'facet-rest';
import { AgentMessageInput }
  from 'Components/ComponentLibrary/Components/Uncategorized/MessageInput/components/AgentMessageInput';

const MessageInput = ({
  className,
  onSubmit,
  onChange,
  onSubjectChange,
  handleAttachmentDelete,
  messageSending,
  messageResource,
  refreshMessages,
  readOnly,
  value,
  dataTestAttributes,
  inputMinHeight,
  inputMaxHeight,
  placeholder,
  borderless,
  rounded,
  showAttachmentsInToolbar,
  onSetAttachments,
  handleTemplateInsert,
}) => {
  const { isAgent } = useUserContext();
  const [text, setText] = React.useState(value);
  const attachmentResources = (messageResource?.attr('attachments')) ? messageResource?.attr('attachments').resources().list() : [];
  const [attachments, setAttachments] = React.useState(attachmentResources);

  const MessagesInput = isAgent ? AgentMessageInput : MemberMessageInput;

  const handleChange = (content) => {
    onChange(content);
    setText(content);
  };

  const handleSubmit = () => {
    onSubmit(text);
    setText('');
    setAttachments([]);
  };

  React.useEffect(() => {
    if (messageResource?.attr('attachments') !== undefined) {
      onSetAttachments();
      setAttachments(messageResource.attr('attachments').resources().list());
    }
  }, [messageResource]);

  React.useEffect(() => {
    if (readOnly) {
      setText('');
    } else {
      setText(value);
    }
  }, [readOnly]);

  return (
    <MessagesInput
      className={className}
      handleSubmit={() => handleSubmit(text)}
      handleChange={(val) => handleChange(val)}
      onSubjectChange={(val) => onSubjectChange(val)}
      handleAttachmentDelete={handleAttachmentDelete}
      messageSending={messageSending}
      messageResource={messageResource}
      handleTemplateInsert={handleTemplateInsert}
      onFileUploadSuccess={refreshMessages}
      readOnly={readOnly}
      value={text}
      attachments={attachments}
      dataTestAttributes={dataTestAttributes}
      inputMinHeight={inputMinHeight}
      inputMaxHeight={inputMaxHeight}
      placeholder={readOnly ? '' : placeholder}
      borderless={borderless}
      rounded={rounded}
      showAttachmentsInToolbar={showAttachmentsInToolbar}
    />
  );
};

MessageInput.defaultProps = {
  className: '',
  messageSending: false,
  onChange: noop,
  onSubmit: noop,
  onSubjectChange: noop,
  handleAttachmentDelete: noop,
  refreshMessages: noop,
  readOnly: false,
  messageResource: null,
  value: '',
  dataTestAttributes: {},
  inputMinHeight: undefined,
  inputMaxHeight: undefined,
  placeholder: 'Reply...',
  borderless: false,
  rounded: false,
  showAttachmentsInToolbar: true,
  handleTemplateInsert: noop,
  onSetAttachments: noop,
};

MessageInput.propTypes = {
  className: PropTypes.string,
  messageSending: PropTypes.bool,
  messageResource: PropTypes.instanceOf(fr.Resource),
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onSubjectChange: PropTypes.func,
  handleAttachmentDelete: PropTypes.func,
  refreshMessages: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  dataTestAttributes: PropTypes.object,
  inputMinHeight: PropTypes.number,
  inputMaxHeight: PropTypes.number,
  placeholder: PropTypes.string,
  borderless: PropTypes.bool,
  rounded: PropTypes.bool,
  showAttachmentsInToolbar: PropTypes.bool,
  handleTemplateInsert: PropTypes.func,
  onSetAttachments: PropTypes.func,
};

export { MessageInput };
